__turbopack_context__.v({
  "adornment": "material-module-scss-module__NUg0Ba__adornment",
  "container": "material-module-scss-module__NUg0Ba__container",
  "error": "material-module-scss-module__NUg0Ba__error",
  "full-width": "material-module-scss-module__NUg0Ba__full-width",
  "input": "material-module-scss-module__NUg0Ba__input",
  "input-with-error": "material-module-scss-module__NUg0Ba__input-with-error",
  "label": "material-module-scss-module__NUg0Ba__label",
  "label-with-error": "material-module-scss-module__NUg0Ba__label-with-error",
  "wrapper": "material-module-scss-module__NUg0Ba__wrapper",
});
